import { Component, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'siat-calendar-action-button',
  standalone: true,
  imports: [MatButtonModule, MatIconModule, MatTooltipModule],
  template: `
    <button
      matButton="filled"
      color="primary"
      [attr.aria-label]="label()"
      [matTooltip]="tooltip() || label()"
      (click)="clicked.emit(label())"
    >
      <mat-icon>add</mat-icon>
      {{ label() }}
    </button>
  `,
})
export class CalendarActionButtonComponent {
  /**
   * The label to display on the button
   */
  label = input.required<string>();

  /**
   * The tooltip to display
   */
  tooltip = input<string>();

  /**
   * The event emitter to emit when the button is clicked
   */
  clicked = output<string>();
}
